import InfoTip, {P} from '../../../components/info-tip/info-tip';

const EmployeeNumberPrefixInfo = function () {
  return (
    <InfoTip
      info={
        <section>
          <h3>身份類別：</h3>
          <P>
            非定期：沒有期限，除非被裁員或自動離職，否則可以持續工作。
            <br />
            定期：有期限，契約到期就須離職，無法繼續工作，除非雇主願意續約。
            <br />
            全職：正職人員。
            <br />
            部分工時：兼職人員。
          </P>
        </section>
      }
    />
  );
};

export default EmployeeNumberPrefixInfo;
